import { Typography } from "@mui/material";
import { Stack } from "@mui/system";
import CheckIcon from "@mui/icons-material/Check";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import KeywordsShortBy from "./KeywordsShortBy";
import { useSelector } from "react-redux";
import { useMemo } from "react";

type Props = {
  value: string | null;
  onChange: (val: string | null) => void;
  sortConfig: any;
  setSortConfig: any;
};

const KeywordsSearchFilter = ({
  value,
  onChange,
  sortConfig,
  setSortConfig,
}: Props) => {
  const { keywordsQueryData } = useSelector(
    (state: any) => state.businessLeaderDashBoard,
  );

  const keywordOptions = useMemo(() => {
    const kewwordsData = keywordsQueryData?.query_output ?? [];
    return kewwordsData.map((item: any) => item.kw_name);
  }, [keywordsQueryData]);

  return (
    <>
      <Typography
        variant="body1"
        sx={{ mt: 1, fontWeight: typography.Font_weight.Medium.$value }}
      >
        Top Keywords
      </Typography>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={1}
        mb={2}
      >
        <Autocomplete
          options={keywordOptions}
          data-tracker="665"
          value={value}
          popupIcon={null}
          onChange={(_, newValue) => onChange(newValue)}
          sx={{
            width: "85%",
            "& .MuiInputBase-input": {
              fontSize: typography.Size.Text.md.$value,
            },
            "& .MuiOutlinedInput-root": {
              paddingRight: spacing.Spacing.none.$value + "!important",
              height: spacing.Spacing["6xl"].$value,
              borderRadius: spacing.Radius.md.$value,
              "&.Mui-focused fieldset": {
                borderColor: colors.GrayLightMode[300].$value,
                borderWidth: "1px",
              },
              "& .MuiAutocomplete-paper": {
                border: `1px solid ${colors.GrayLightMode[300].$value}`,
                borderRadius: spacing.Radius.md.$value,
                boxShadow: "none", // optional
              },
            },
          }}
          size="medium"
          renderOption={(props, option, { selected }) => (
            <li
              {...props}
              style={{
                display: "flex",
                alignItems: "center",
                paddingLeft: spacing.Spacing["5xl"].$value,
                position: "relative",
                backgroundColor: selected ? colors.Brand[50].$value : "",
              }}
            >
              {selected && (
                <CheckIcon
                  fontSize="small"
                  sx={{
                    position: "absolute",
                    left: spacing.Spacing.lg.$value,
                  }}
                />
              )}
              <span>{option}</span>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              color="secondary"
              placeholder="Search for specific Keyword..."
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {!value && (
                      <SearchOutlinedIcon
                        sx={{
                          color: colors.GrayLightMode[400].$value,
                          cursor: "pointer",
                          mr: spacing.Spacing.sm.$value,
                        }}
                      />
                    )}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
        <KeywordsShortBy sortConfig={sortConfig} setSortConfig={setSortConfig} />
      </Stack>
    </>
  );
};

export default KeywordsSearchFilter;
